module.exports = __webpack_public_path__ + "media/skeleton.efebc7cd.wav";